<template>
  <div class="reviewHDDT mb-4">
    <div class="header header-before">
      <div class="logo">
        <a href="#"><img src="@/assets/img/Nextpay-logo-white.svg" alt="" /></a>
        <h1>Xác nhận bàn giao thiết bị</h1>
      </div>
    </div>
    <!-- Main -->
    <div class="main">
      <div
        v-if="dataContract && !['SUCCESS', 'REJECTED'].includes(dataContract.statusHandover)"
        class="title-main py-2"
      >
        <div class="py-1 d-flex justify-content-end">
          <b-button
            :disabled="loadingBtn"
            variant="danger"
            @click="actionCustomer('REJECTED')"
            class="mx-2"
            >Từ chối</b-button
          >
          <b-button
            :disabled="loadingBtn"
            variant="primary"
            @click="actionCustomer('SUCCESS')"
            class="mx-2"
            >Xác nhận</b-button
          >
        </div>
      </div>

      <div v-if="dataContract" class="contract" style="padding: 10px 100px !important">
        <Header groupService="PAYMENT"></Header>
        <p class="txt-tranf txt-center fonsize-20">
          <b>XÁC NHẬN BÀN GIAO THIẾT BỊ </b>
        </p>
        <div style="margin-top: 30px"></div>
        <p>Căn cứ:</p>
        <p>
          - Hợp đồng hợp tác chấp nhận thanh toán số
          <mark>{{
            dataContract?.isNganluongContract ? dataContract.codeOfContract : dataContract.code
          }}</mark>
          ><br />
        </p>
        <p>
          (sau đây được viết tắt là “Hợp đồng”) ký
          <mark>{{ getDayFormat(dataContract.signDate) }}</mark>
        </p>
        <div style="margin-top: 30px"></div>
        <p>
          Hôm nay, <mark>{{ getDayFormat(Date.now()) }}</mark
          >tại Công ty Cổ phần Công nghệ Vi mô
        </p>
        <p><b>Chúng tôi gồm: </b></p>
        <p><b>Bên bàn giao (Bên A): </b></p>
        <p>
          - Ông (Bà):
          <mark
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >{{ 'Đỗ Công Diễn' }}</mark
          >
          <mark v-else>{{ 'Nguyễn Tiến Lượng' }}</mark>
          <span style="margin-left: 30px">
            Chức vụ:<mark>{{ 'Tổng giám đốc' }}</mark>
          </span>
        </p>
        <p>
          Đại diện cho:<mark>{{ 'Công ty Cổ phần Công nghệ Vi mô' }}</mark>
        </p>
        <p><b>Bên bàn giao (Bên B): </b></p>
        <p>
          - Ông (Bà):<mark>{{ dataContract.customerName }}</mark>
          <span style="margin-left: 30px">
            Chức vụ:<mark>{{ dataContract.position || '' }}</mark>
          </span>
        </p>
        <p>
          Đại diện cho:<mark>{{ dataContract.merchantName }}</mark>
        </p>
        <p>Nội dung bàn giao như sau:</p>
        <ul class="dk-list">
          <li>
            <p>
              <span class="ml-3">1</span> Bên A tiến hành bàn giao
              <mark>{{ dataContract.devices.length }}</mark> thiết bị cho Bên B, cụ thể:
            </p>
            <table>
              <th>STT</th>
              <th>Loại thiết bị</th>
              <th>Serial thiết bị</th>
              <th>Giá bán</th>
              <tr v-for="(item, i) in dataContract.devices" :key="i">
                <td>
                  <mark>{{ i + 1 }}</mark>
                </td>
                <td>
                  <mark>{{ item.name }}</mark>
                </td>
                <td>
                  <mark>{{ item.serialNumber }}</mark>
                </td>
                <td>
                  <mark>{{ item.price | transformMoney }}</mark>
                </td>
              </tr>
            </table>
          </li>
          <li>
            <p>
              <span class="ml-3">2.</span> Bên A bảo đảm cung cấp hàng hoá đúng nhãn hiệu của hãng
              sản xuất. Sản phẩm được kiểm tra, cài đặt và đảm bảo hoạt động tốt với hệ thống thanh
              toán thẻ mPOS.vn trước khi bàn giao cho Bên B.
            </p>
          </li>
        </ul>
        <Footer
          :dataContract="dataContract"
          :isAppendix="true"
          :customerName="dataContract.customerName"
          :sign="dataContract.images && dataContract.images[0]"
        ></Footer>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Header from '../../../components/contracts/block/header.vue'
  import Footer from '../../../components/contracts/block/footer.vue'
  import { ContractService } from '@/services/contract.service'
  import { DeviceService } from '../../../services/device.service'
  import moment from 'moment'
  import md5 from 'md5'
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        dataContract: null,
        loadingBtn: false,
        showLoading: true,
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const time = moment().valueOf()
          const params = {
            appendixId: this.$route.query.appendixId,
            contractId: this.$route.query.contractId,
            checksum: md5(`FQY0DYG7V89OT52B${time}`),
            time,
          }
          const dataContractRespon = await ContractService.getAppendixByIdInPublic(params)
          if (dataContractRespon.code === 1000) {
            this.dataContract = dataContractRespon.data
            console.log(this.dataContract)
          } else throw dataContractRespon.message
        } catch (error) {
          this.showLoading = false
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async actionCustomer(action) {
        try {
          this.loadingBtn = true
          this.showLoading = true
          const time = moment().valueOf()
          const params = {
            appendixId: this.$route.query.appendixId,
            contractId: this.$route.query.contractId,
            checksum: md5(`FQY0DYG7V89OT52B${time}`),
            time,
            action,
          }
          const response = await DeviceService.customerActionConfirmInPublic(params)
          if (response.code === 1000) {
            this.showSuccessMx(
              `[${action === 'SUCCESS' ? 'Xác nhận' : 'Từ chối'}] ${response.message}.`
            )
            this.dataContract.statusHandover = action
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          console.log('error::: ', error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.loadingBtn = false
          this.showLoading = false
        }
      },

      getDayFormat(timestamp) {
        return `ngày ${moment(timestamp).date()} tháng ${moment(timestamp).month() + 1} năm ${moment(timestamp).year()}`
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>

<style scoped>
  .text-center {
    text-align: center !important;
  }
</style>
